module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bn-43328fe6ecf986eab3fecf82b8265b78.svg";